import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "react-quill/dist/quill.snow.css";
import "./index.scss";
import App from "./App";
import SytProvider from "../src/common/providers/SytProvider";

import {
  AuthProvider,
  CurrencyProvider,
  GlobalStatesProvider,
} from "../src/common/providers/";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <SytProvider>
          <CurrencyProvider>
            <GlobalStatesProvider>
              <App />
            </GlobalStatesProvider>
          </CurrencyProvider>
        </SytProvider>
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);
